export default __webpack_public_path__ + "static/media/chhattisgarhi_lang.d8649afb.png";